import { Outlet } from "react-router-dom";

export default function MobileLayout() {
  return (
    <div className="mobile-layout">
      <Outlet />
    </div>
  );
}
